import { jsx as _jsx } from "react/jsx-runtime";
/*
 * A typescript & react boilerplate with api call example
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { AppPage, ATS_ActionProcessor, ATS_CollectionUpgrades, ATS_CrudOperations, ATS_ProtoComponent, ATS_ProtoComponentDouble, ATS_SyncEnvironment, ModuleFE_Thunderstorm, TS_AppTools } from '@nu-art/thunderstorm-frontend/index';
import { playgroundScreens } from '../../playground/index.js';
import { KnowledgeManagerOverlay } from '../../knowledge-manager/Page_KnowledgeManager/Page_KnowledgeManager.js';
import { ATS_DevPreps } from '../../dev-screens/dev-prep/DevPage_DevPreps.js';
import { ATS_SnomedDictionaryActions } from '../../dev-screens/snomed-dictionary/DevPage_SnomedDictionaryActions.js';
import { ATS_AccountEditor } from '@nu-art/user-account-frontend/_ats/account-editor/ATS_AccountEditor';
import { ATS_ComponentPermissionKeys, ATS_Permissions, RoutePermissions } from '@nu-art/permissions-frontend/index';
import { Outlet } from 'react-router';
import { ATS_SessionData } from '@nu-art/user-account-frontend/_ats_session-data/ATS_SessionData';
import { ATS_Toaster } from '@nu-art/thunderstorm-frontend/_ats/ATS_Toaster/index';
import { ATS_PushPubSub } from '@nu-art/push-pub-sub-frontend/ui/ATS_PushPubSub/index';
import { PermissionKeyFE_DeveloperViewer } from '@nu-art/permissions-frontend/core/permission-keys';
import { Component_AccountThumbnail, ModuleFE_Account, PopUp_AccountMenu } from '@nu-art/user-account-frontend/index';
import { ATS_EditableItemTesting } from '@nu-art/thunderstorm-frontend/_ats/ATS_EditableItem/ATS_EditableItem';
import { ATS_ExpressionBuildingUtils } from '@app/hcs-frontend/ats';
import { ATS_ExpressionBuilder } from '@app/hcs-frontend/ats';
import { ATS_ShortUrl } from '@nu-art/ts-short-url-frontend/_ats/index';
import { ATS_DependencyViewer } from '@nu-art/ts-dependency-viewer-frontend/_ats/index';
import { ATS_SlackMessageBuilder } from '@nu-art/slack-frontend/ats';
import { ModuleFE_User } from '@app/org-frontend';
import { ATS_IDBCacheComparison } from '@nu-art/thunderstorm-frontend/_ats/ATS_IDBCacheComparison/ATS_IDBCacheComparison';
import { ATSGroup_ConflictResolution } from '@nu-art/conflict-resolution-frontend/_ats/index';
import { ATS_Tooltip_Finding } from '@app/advisor-ui-frontend/ui/Tooltip_Finding/tests/ATS_Tooltip_Finding';
import { Component_UserDetailsEditor } from '../../knowledge-manager/components/Component_Header/Component_UserDetailsEditor/Component_UserDetailsEditor.js';
const screens = [
    ...playgroundScreens,
    ATS_Permissions.screen,
    ATS_Toaster.screen,
    ATS_AccountEditor.screen,
    ATS_ActionProcessor.screen,
    ATS_CollectionUpgrades.screen,
    ...ATSGroup_ConflictResolution,
    ATS_CrudOperations.screen,
    ATS_EditableItemTesting.screen,
    ATS_SyncEnvironment.screen,
    ATS_ExpressionBuildingUtils.screen,
    ATS_ExpressionBuilder.screen,
    ATS_PushPubSub.screen,
    ATS_DevPreps,
    ATS_SnomedDictionaryActions,
    ATS_ComponentPermissionKeys.screen,
    ATS_SessionData.screen,
    ATS_ProtoComponent.screen,
    ATS_ProtoComponentDouble.screen,
    ATS_ShortUrl.screen,
    ATS_DependencyViewer.screen,
    ATS_SlackMessageBuilder.screen,
    ATS_IDBCacheComparison.screen,
    ATS_Tooltip_Finding,
];
export class Page_Main extends AppPage {
    static renderAccountThumbnail = () => {
        const user = ModuleFE_User.getUser();
        if (!user)
            return;
        return _jsx(Component_AccountThumbnail, { accountId: () => user._id, modulesToAwait: [ModuleFE_User, ModuleFE_Account], onClick: e => {
                PopUp_AccountMenu.show(e, {
                    accountId: user._id,
                    menuActions: [
                        PopUp_AccountMenu.Action_EditPassword,
                        {
                            label: 'Edit My Details',
                            type: 'page',
                            pageKey: 'edit-my-details',
                            content: (account, trigger) => _jsx(Component_UserDetailsEditor, { account: account, onSubmitCompleted: trigger })
                        },
                        {
                            label: 'Go To KM',
                            type: 'action',
                            closePopUp: true,
                            action: () => {
                                ModuleFE_Thunderstorm.openUrl('/km', '_blank');
                            }
                        }
                    ]
                });
            } });
    };
    static Route = {
        path: '/',
        key: 'root',
        Component: this,
        fallback: true,
        children: [
            KnowledgeManagerOverlay.Route,
            {
                ...TS_AppTools.createRoute(screens, 'app-tools', Page_Main.renderAccountThumbnail),
                enabled: RoutePermissions(PermissionKeyFE_DeveloperViewer)
            }
        ]
    };
    constructor(props) {
        super(props);
    }
    deriveStateFromProps(nextProps) {
        return {};
    }
    render() {
        return _jsx(Outlet, {});
    }
}
